import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./App";
import { Providers } from "./Providers";
import { msalConfig, isMsalConfigured } from "./auth/msalConfig";
import "./globals.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);

const app = (
  <Providers>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Providers>
);

if (isMsalConfigured) {
  const msalInstance = new PublicClientApplication(msalConfig);
  root.render(
    <MsalProvider instance={msalInstance}>
      {app}
    </MsalProvider>
  );
} else {
  root.render(app);
}
